import { render } from "./DacklHeaderBar.vue?vue&type=template&id=30141b16&ts=true"
import script from "./DacklHeaderBar.vue?vue&type=script&lang=ts"
export * from "./DacklHeaderBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__